module.exports = __webpack_public_path__ + "static/media/money.890d2428.png";